<template>
  <div class="text-message h-full">
    <BaseContainer>
      <template slot="content">
        <div class="admin-list-wrap">
          <div class="amount">
            <div>
              <div class="mb-1 text-medium text-theme-black-650">当前短信余额(条)</div>
              <div class="text-theme-black-850 font-semibold text-large-x">{{ textMessageData.balance }}</div>
            </div>
            <div class="line"></div>
            <div class="pl-6">
              <div class="mb-1 text-medium text-theme-black-650">
                累计充值数量(条)
                <el-tooltip popper-class="popper-box" content="短信可用于向样本发送短信，验证样本的手机号" placement="top" effect="light">
                  <i class="iconfont icon-shuoming text-theme-black-350 cursor-pointer"></i>
                </el-tooltip>
              </div>
              <div class="text-theme-black-850 font-semibold text-large-x">{{ textMessageData.total }}</div>
            </div>
            <div></div>
          </div>
          <el-button type="primary" plain size="mini" class="mt-2" @click="buyMsgVisible = true">购买短信</el-button>
        </div>
      </template>
    </BaseContainer>
    <!-- 短信支付的弹窗 -->
    <el-dialog
      title="购买短信"
      :visible.sync="buyMsgVisible"
      width="600px"
      destroy-on-close
      :before-close="handleCloseDialog">
      <div class="flex text-medium text-theme-black-850 leading-22 border-b border-solid border-gray-400">
        <div>
          <div>购买数量（条）：</div>
          <div>（0.1元/条）</div>
        </div>
        <div class="flex-1 ml-3">
          <el-radio-group v-model="buyType">
            <el-radio-button label="10"></el-radio-button>
            <el-radio-button label="30"></el-radio-button>
            <el-radio-button label="50"></el-radio-button>
            <el-radio-button label="100"></el-radio-button>
            <el-radio-button label="200"></el-radio-button>
            <el-radio-button label="500"></el-radio-button>
            <el-radio-button label="其他"></el-radio-button>
          </el-radio-group>
          <el-form :model="otherNumForm" :rules="otherNumRule" ref="otherNumForm" v-if="buyType === '其他'">
            <el-form-item prop="otherNum">
              <el-input-number v-model="otherNumForm.otherNum" controls-position="right" @change="otherNumChange" :precision="0" :min="0"/>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="text-medium text-theme-black-850 leading-22 mt-2">
        <div>应付金额（元）：<span class="text-red">{{ msgAmount }}</span></div>
        <div>当前账户余额（元）：<span>{{ transformMoney(balance).toLocaleString() }}</span></div>
        <div v-if="payAmount > 0">还需支付（元）：<span>{{ payAmount }}</span></div>
      </div>
      <div class="flex justify-end">
        <el-button type="primary" class="normal-button" @click="buyMassage" v-if="payAmount > 0">支付</el-button>
        <el-button type="primary" @click="buyMassage" v-else>账户余额支付</el-button>
      </div>
    </el-dialog>
    
    <!-- 二维码弹窗 -->
    <el-dialog
      title="请微信扫码充值"
      :visible.sync="codeDialogVisible"
      width="30%"
      :before-close="handleCodeClose">
      <vue-qr
        class="m-auto"
        :text="codeUrl"
        :margin="0"
        :size="200"
        style="display: block;"
      />
      <div class="text-medium-x text-theme-black-850 text-center mt-4">充值仅限本人充值，暂不支持他人代充值</div>
    </el-dialog>
  </div>
</template>
  
<script>
import VueQr from 'vue-qr'
import BaseContainer from '@/layout/base/BaseContainer'
import { getCustomerCaptial, textMessageInfoApi } from '@/api/company/money'
import { buyTextMsgInCompany, weChatCharge, getWeChatChargeStatus } from '@/api/company/message'

export default {
  name: 'TextMessage',
  components: { BaseContainer, VueQr },
  data() {
    return {
      textMessageData: {},
      customerCapital: {},
      YinLianCustomerCapital: {},
      buyMsgVisible: false,
      buyType: '',
      msgAmount: '',
      balance: 0,
      payAmount: 0,
      otherNumForm: {
        otherNum: ''
      },
      otherNumRule: {
        otherNum: [
          { validator:(rule,value,callback) => {
              if (value % 10 === 0 && value > 0) {
                callback()
              } else {
                callback(new Error("请输入10的整数倍"))
              }
            }, trigger: 'blur'
          }
        ]
      },
      codeDialogVisible: false, // 支付二维码弹窗的显隐
      codeUrl: '',
      timer: null,
      codeTimer: null
    }
  },
  watch: {
    buyType(val) {
      if(val === '其他') {
        this.msgAmount = ''
        return
      }
      this.msgAmount = val / 10 || ''
    },
    msgAmount(val) {
      this.payAmount = Number(val) - this.transformMoney(this.balance)
    }
  },
  methods: {
    // 关闭二维码弹窗
    handleCodeClose() {
      this.codeDialogVisible = false
      clearInterval(this.codeTimer)
      clearInterval(this.timer)
    },
    // 购买短信
    buyMassage() {
      if(this.payAmount <= 0) {
        // 用账户余额购买
        buyTextMsgInCompany(0, this.msgAmount * 10).then(res => {
          this.getMoneyData()
          this.getMessageData()
          this.handleCloseDialog()
          this.$message.success('短信购买成功')
        }).catch((err) => {console.log(err)})
      } else {
        // 先充值，再用余额购买(每隔15分钟刷新二维码)
        this.rechargeBuyMsg()
        this.codeTimer = setInterval(() => {this.rechargeBuyMsg()}, 900000)
      }
    },
    // 充值购买短信
    rechargeBuyMsg() {
      clearInterval(this.timer)
      weChatCharge(this.numMulti(this.payAmount, 100), 0).then(res => {
        if (res.innerId && res.qrcode) {
          this.codeUrl = res.qrcode
          this.codeDialogVisible = true
          // 轮询查看是否充值成功
          this.getChargeStates(res.innerId, this.msgAmount * 10)
        } else if (!this.codeUrl) {
          clearInterval(this.codeTimer)
        }
      }).catch((err) => {console.log(err)})
    },
    // 轮询充值状态
    getChargeStates(innerId, total) {
      this.timer = setInterval(() => {
        getWeChatChargeStatus(innerId).then(res => {
          if (res.status === "SUCCESS") {
            clearInterval(this.timer)
            // 充值成功，用账户余额购买
            buyTextMsgInCompany(0, total).then(res => {
              this.getMoneyData()
              this.getMessageData()
              this.handleCodeClose()
              this.handleCloseDialog()
            }).catch((err) => {console.log(err)})
          } else if (res.status === "PAYERROR") {
            this.$message.error("支付失败")
            this.handleCodeClose()
          }
        })
      }, 2000)
    },
    // 金额规范至单位（元）
    transformMoney(money) {
      const yuan = (money / 100).toFixed(2)
      return parseFloat(yuan)
    },
    // 其他短信数量的修改
    otherNumChange(value) {
      this.msgAmount = value / 10
    },
    handleCloseDialog() {
      this.buyMsgVisible = false
      this.payAmount = 0
      this.otherNumForm.otherNum = ''
      this.buyType = ''
      this.msgAmount = ''
    },
    // 乘法运算，避免数据相乘小数点后产生多位数和计算精度损失
    numMulti(num1, num2) {
      let baseNum = 0
      try {
        baseNum += num1.toString().split(".")[1].length
      } catch (e) {console.log(e)}
      try {
        baseNum += num2.toString().split(".")[1].length
      } catch (e) {console.log(e)}
      return ((Number(num1.toString().replace(".", "")) * Number(num2.toString().replace(".", ""))) / Math.pow(10, baseNum))
    },
    // 获取钱包信息
    getMoneyData() {
      getCustomerCaptial().then(res => {
        this.customerCapital = res
        this.YinLianCustomerCapital = res.companyUnipay
        this.balance = res.balance
      }).catch((err) => {console.log(err)})
    },
    // 获取短信数据
    getMessageData() {
      textMessageInfoApi({companyId: 0}).then(res => {
        this.textMessageData = res
      }).catch((err) => {console.log(err)})
    }
  },
  created() {
    this.getMoneyData()
    this.getMessageData()
  }
}
</script>

<style scoped lang="scss">
.admin-list-wrap {
  width: 580px;
  background: #FFFFFF;
  box-shadow: 0 1px 4px 0 #0000000f;
  border-radius: 4px;
  padding: 16px;
  .amount {
    display: flex;
    & > div {
      flex: 1;
    }
    .line {
      flex: none;
      width: 1px;
      height: 32px;
      flex: none;
      background: #D9DDE0;
      padding: 0;
      margin-top: 8px;
    }
  }
}
::v-deep .el-dialog__header {
  background: #F5F7FA;
  padding: 12px 16px;
}
::v-deep .el-dialog__body {
  padding: 24px 16px;
}
::v-deep .el-radio-group {
  display: flex;
  flex-wrap: wrap;
  .el-radio-button {
    width: 98px;
    height: 30px;
    margin-bottom: 18px;
    margin-right: 28px;
    span {
      display: block;
      border-radius: 2px;
      border: 1px solid rgba(0,0,0,.1);
    }
  }
}
</style>
